import { Link } from 'gatsby';
import IndoorArticles from 'components/FAQs/IntroIndoorFAQ';
import OutdoorArticles from 'components/FAQs/IntroOutdoorFAQ';
import NavButtons from 'components/Products/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  IndoorArticles,
  OutdoorArticles,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};